export type { Placement as TooltipPlacement } from '@popperjs/core'
import { placements } from '@popperjs/core'

export const TOOLTIP_PLACEMENTS = new Set(placements)
